import {TranslationKey} from '@enums'
import {Button, Grid, Stack, Typography} from '@mui/material'

import React from 'react'

import {renderFormField} from 'common'
import {RemoveButton} from 'components/pages/dealers/dealer-form/style'

import {ComposedComponents, UIKit} from '@components'

import {useProductFormModel} from './product-form-model'
import {ButtonWrapper, PriceTitleWrapper, RemoveButtonIcon} from './style'

/**
 * Product Form page
 */
export function ProductFormPage() {
  const {
    onDiscard,
    onSubmit,
    onAddProductPrice,
    productPriceFormFields,
    onRemoveProductPrice,
    productPricePerLengthFormFields,
    isAddPriceBtnDisabled,
    t,
    productDefaultPriceFormFields,
    productGeneralFormFields,
    productData,
  } = useProductFormModel()

  return (
    <>
      <UIKit.BackgroundCard>
        <Grid container spacing={2}>
          {productGeneralFormFields.map((item, index) => (
            <Grid sm={3} item key={`product-general-form-field-${index}`}>
              {renderFormField(item)}
            </Grid>
          ))}
        </Grid>
      </UIKit.BackgroundCard>

      <UIKit.BackgroundCard title={t(TranslationKey.Prices)}>
        <Stack gap={2}>
          <UIKit.BackgroundCard title={t(TranslationKey['Default prices'])}>
            <Grid container spacing={2}>
              {productDefaultPriceFormFields.map((item, index) => (
                <Grid sm={3} item key={`product-price-form-field-${index}`}>
                  {renderFormField(item)}
                </Grid>
              ))}
            </Grid>
          </UIKit.BackgroundCard>
          {productData.contractTypePrices.map((item, index) => (
            <UIKit.BackgroundCard key={`contract-type-prices-card-${index}`}>
              <PriceTitleWrapper>
                <Typography fontWeight={'bold'}>{`${t(TranslationKey.Price)} ${index + 1}`}</Typography>
                <RemoveButton onClick={() => onRemoveProductPrice(index)} startIcon={<RemoveButtonIcon />}>
                  {t(TranslationKey['Remove price'])}
                </RemoveButton>
              </PriceTitleWrapper>
              <Stack gap={2}>
                <Grid container spacing={2}>
                  {productPriceFormFields(index).map((item, setIndex) => (
                    <Grid sm={setIndex === 0 ? 6 : 3} item key={`product-price-form-field-${index}-${setIndex}`}>
                      {renderFormField(item)}
                    </Grid>
                  ))}
                </Grid>
                <Stack>
                  <Stack alignItems={'flex-start'}>
                    <Typography fontWeight={'bold'}>{t(TranslationKey['Custom monthly fees'])}</Typography>
                  </Stack>
                  <Grid container spacing={2}>
                    {productPricePerLengthFormFields(index).map((item, setIndex) => (
                      <Grid sm={3} item key={`product-price-per-length-form-field-${index}-${setIndex}`}>
                        {renderFormField(item)}
                      </Grid>
                    ))}
                  </Grid>
                </Stack>
              </Stack>
            </UIKit.BackgroundCard>
          ))}
          {!isAddPriceBtnDisabled && (
            <ButtonWrapper>
              <Button variant="contained" onClick={onAddProductPrice}>
                {t(TranslationKey['Add price'])}
              </Button>
            </ButtonWrapper>
          )}
        </Stack>
      </UIKit.BackgroundCard>

      <ComposedComponents.FormButtons
        leftButton={{label: t(TranslationKey.Discard), onClick: onDiscard}}
        rightButton={{label: t(TranslationKey.Save), onClick: onSubmit}}
      />
    </>
  )
}
